import { egtoFormGroupState } from './form-group-state.directive';
import { languageSwitcher } from './language-switcher.directive';
import { egtoMustMatch } from './must-match.directive';
import { egtoMustNotMatch } from './must-not-match.directive';
import { egtoPassword }  from './password.directive';
import { egtoCustomValidation } from './egto-custom-validation.directive';
import { passwordValidator } from './password-validator.directive';
import { egtoUniqueValidation } from './unique-validation.directive';
import { installationLogo } from './installation-logo.directive';
import { authenticationHeader } from './authentication-header.directive';
import { authenticatedUsers } from './authenticated-users.directive';
import { egtoDomain } from './egto-domain.directive';
import { toolbarClose } from './toolbar-close.directive';
import { egLogo } from './eg-logo.directive';
import { egtoVerificationField } from './verification-field.directive';
import { egtoMobileNumber } from './mobile-number.directive';
import { popoverState } from './popover-state';

import { hasAccess } from './has-access.directive';

export var componentsModule = angular.module('authentication.components', [
        'pascalprecht.translate'
    ])
    .directive('egtoFormGroupState', egtoFormGroupState)
    .directive('languageSwitcher', languageSwitcher)
    .directive('egtoMustMatch', egtoMustMatch)
    .directive('egtoMustNotMatch', egtoMustNotMatch)
    .directive('egtoPassword', egtoPassword)
    .directive('egtoCustomValidation', egtoCustomValidation)
    .directive('passwordValidator', passwordValidator)
    .directive('egtoUniqueValidation', egtoUniqueValidation)
    .directive('installationLogo', installationLogo)
    .directive('authenticationHeader', authenticationHeader)
    .directive('authenticatedUsers', authenticatedUsers)
    .directive('egtoDomain', egtoDomain)
    .directive('toolbarClose', toolbarClose)
    .directive('egLogo', egLogo)
    .directive('egtoVerificationField', egtoVerificationField)
    .directive('egtoMobileNumber', egtoMobileNumber)
    .directive('popoverState', popoverState)
    .directive('hasAccess', hasAccess)
    ;
